import React, {useCallback, useState} from 'react';
import './NoJobFoundComponent.scss';
import {ImageConfig} from "../../constants";
import ButtonComponent from "../ant-component/button-component/ButtonComponent";
import JobApplicationFormComponent from "../../app/job-board/job-application-form/JobApplicationFormComponent";
import ModalComponent from "../modal/ModalComponent";
const NoJobsFoundComponent = () => {
    const [isModalVisible, setIsModalVisible] = useState<boolean>(false);
    const [isMobileView] = useState(window.innerWidth <= 768);

    const handleApply=useCallback(()=>{
        setIsModalVisible(true)
    },[])

    const onCloseModal = useCallback(() => {
        setIsModalVisible(false);
    }, []);

    return (
        <>
            <ModalComponent
                open={isModalVisible}
                onCancel={() => setIsModalVisible(false)}
                width={isMobileView ? '100%' : 600}
                title='Apply For This Job'
                destroyOnClose={true}
                footer={null}
            >
                <JobApplicationFormComponent
                    jobId={''}
                    onCloseModal={onCloseModal}
                />
            </ModalComponent>
        <div className='no-jobs-found-component'>
            <div className='no-jobs-content'>
                <div className='no-jobs-icon'>
                    <img
                        src={ImageConfig.NoJobImage}
                        alt="No jobs found"
                        className='no-jobs-image'
                    />
                </div>

                <div className='no-jobs-text'>
                    <h2 className='no-jobs-title'>
                        Oops, Sorry we didn't find a role that matches your search..!
                    </h2>
                    <p className='no-jobs-subtitle'>
                        Try adjusting your filters or check back later — we'd love to help you find the perfect fit!
                    </p>
                </div>
                <ButtonComponent
                    onClick={handleApply}
                    type={'button'} color={'primary'} variant={'solid'} size={'large'}>
                    <span className='upload-icon'>↑</span>
                    Upload Resume
                </ButtonComponent>
            </div>
        </div>
        </>
    );
};

export default NoJobsFoundComponent;